module.exports = __webpack_public_path__ + "static/img/rank_273.cd50435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_273.png
// module id = Ln4O
// module chunks = 1